import { useMemo } from "react";
import Grouped from "./Grouped";

const TYPE = {
  grouped: Grouped,
};

const List = ({ type = "grouped", ...props }) => {
  const View = useMemo(() => TYPE[type], [type]);
  return <View {...props} />;
};

export default List;
